import LinkListNavigation from 'components/Navigation/renditions/LinkListNavigation'
import React from 'react'

class HorizontalLinkListNavigation extends React.PureComponent {
  render() {
    return <LinkListNavigation {...this.props} horizontal />
  }
}

export default HorizontalLinkListNavigation
